import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Clock, ArrowLeft } from '@phosphor-icons/react';

const PendingActivationPage = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] p-8">
      <div className="w-full max-w-lg text-center">
        <div className="bg-white border border-[#E4E4E7] p-12">
          <div className="w-16 h-16 mx-auto mb-6 bg-[#F59E0B]/10 flex items-center justify-center">
            <Clock size={32} weight="bold" className="text-[#F59E0B]" />
          </div>

          <h1 className="font-heading text-2xl font-bold tracking-tight text-[#0A0A0A] mb-3">
            Account in attesa di attivazione
          </h1>

          <p className="text-[#52525B] mb-6 leading-relaxed">
            Il tuo account <strong>{email}</strong> è stato creato con successo.
          </p>

          <div className="bg-[#F59E0B]/5 border border-[#F59E0B]/30 p-6 mb-8 text-left">
            <p className="text-sm text-[#0A0A0A] leading-relaxed">
              Non appena l'amministratore avrà approvato la tua utenza e ti avrà assegnato
              al team di appartenenza, potrai accedere alla piattaforma utilizzando il tuo
              account Microsoft Entra ID.
            </p>
          </div>

          <p className="text-xs text-[#A1A1AA] mb-6">
            Riceverai una notifica quando il tuo account sarà attivo.
          </p>

          <Link to="/login" className="inline-flex items-center gap-2 text-sm font-medium text-[#002FA7] hover:underline" data-testid="back-to-login-link">
            <ArrowLeft size={16} weight="bold" />
            Torna al login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PendingActivationPage;
